export const iconFontAwesomeArrowsArrowsLeftRight = (
	<i className="fa-solid fa-arrows-left-right"></i>
);
